/* tslint:disable */
/* eslint-disable */

/**
 * 0 = MyTasks
 * 
 * 1 = Workshop
 * 
 * 2 = Servicing
 * 
 * 3 = LoadcellInformation
 * 
 * 4 = AutomaticProcessing
 */
export enum SiteOrigin {
  MyTasks = 0,
  Workshop = 1,
  Servicing = 2,
  LoadcellInformation = 3,
  AutomaticProcessing = 4
}
